export const TypeOfWorksTypes = {
  OTHER: "OTHER",
  CONCRETING: "CONCRETING",
  WELDING: "WELDING",
  CABLING: "CABLING",
  PALIFICATION: "PALIFICATION",
  DRILLING_WELLS: "DRILLING_WELLS",
  INSTALLATION_STRUCTURE: "INSTALLATION_STRUCTURE",
  ANTI_CORROSION_PROTECTION: "ANTI_CORROSION_PROTECTION",
  AUTOMATIC_FIRE_EXTINGUISHING_INSTALLATIONS: "AUTOMATIC_FIRE_EXTINGUISHING_INSTALLATIONS",
  INTERNAL_WATER_SUPPLY_AND_SEWERAGE_NETWORKS: "INTERNAL_WATER_SUPPLY_AND_SEWERAGE_NETWORKS",
  INTERNAL_POWER_SUPPLY_NETWORKS: "INTERNAL_POWER_SUPPLY_NETWORKS",
  INSTALLATION_AND_COMMISSIONING_OF_AUTOMATION_SYSTEMS: "INSTALLATION_AND_COMMISSIONING_OF_AUTOMATION_SYSTEMS",
  INSTALLATION_OF_ELEVATORS: "INSTALLATION_OF_ELEVATORS",
  INSTALLATION_OF_TECHNOLOGICAL_EQUIPMENT_AND_PIPELINES: "INSTALLATION_OF_TECHNOLOGICAL_EQUIPMENT_AND_PIPELINES",
  EXTERNAL_WATER_SUPPLY_AND_SEWERAGE_NETWORKS: "EXTERNAL_WATER_SUPPLY_AND_SEWERAGE_NETWORKS",
  EXTERNAL_POWER_SUPPLY_NETWORKS: "EXTERNAL_POWER_SUPPLY_NETWORKS",
  CIVIL_WORKS: "CIVIL_WORKS",
  FIRE_AND_SECURITY_AND_FIRE_ALARMS: "FIRE_AND_SECURITY_AND_FIRE_ALARMS",
  HEATING_AND_VENTILATION_NETWORKS: "HEATING_AND_VENTILATION_NETWORKS",
  HEATING_NETWORK: "HEATING_NETWORK",
  CONSTRUCTION_OF_FOUNDATIONS: "CONSTRUCTION_OF_FOUNDATIONS",
  BEARING_AND_ENCLOSING_STRUCTURES: "BEARING_AND_ENCLOSING_STRUCTURES",
  ROOF: "ROOF",
  EXTERNAL_FINISHING_WORKS: "EXTERNAL_FINISHING_WORKS",
  INTERIOR_FINISHING_WORKS: "INTERIOR_FINISHING_WORKS",
  VENTILATION_AND_AIR_CONDITIONING: "VENTILATION_AND_AIR_CONDITIONING",
  GAS_PIPELINE: "GAS_PIPELINE",
  COMMUNICATION_SIGNALING_AND_AUTOMATION_SYSTEMS: "COMMUNICATION_SIGNALING_AND_AUTOMATION_SYSTEMS",
  IMPROVEMENT_OF_THE_TERRITORY: "IMPROVEMENT_OF_THE_TERRITORY",
  ROAD_CONSTRUCTION: "ROAD_CONSTRUCTION",
  TECHNOLOGICAL_SOLUTIONS: "TECHNOLOGICAL_SOLUTIONS",
} as const;

export type TypeOfWorksEnum = (typeof TypeOfWorksTypes)[keyof typeof TypeOfWorksTypes];

export const WorkLabels: Record<TypeOfWorksEnum, string> = {
  [TypeOfWorksTypes.AUTOMATIC_FIRE_EXTINGUISHING_INSTALLATIONS]: "Автоматические установки пожаротушения",
  [TypeOfWorksTypes.ANTI_CORROSION_PROTECTION]: "Антикоррозионная защита сварных соединений",
  [TypeOfWorksTypes.CONCRETING]: "Бетонирование",
  [TypeOfWorksTypes.IMPROVEMENT_OF_THE_TERRITORY]: "Благоустройство территории",
  [TypeOfWorksTypes.DRILLING_WELLS]: "Бурение скважин под сваи",
  [TypeOfWorksTypes.VENTILATION_AND_AIR_CONDITIONING]: "Вентиляция и кондиционирование",
  [TypeOfWorksTypes.INTERIOR_FINISHING_WORKS]: "Внутренние отделочные работы (полы, стены, потолки)",
  [TypeOfWorksTypes.INTERNAL_WATER_SUPPLY_AND_SEWERAGE_NETWORKS]: "Внутренние сети водопровода и канализации",
  [TypeOfWorksTypes.INTERNAL_POWER_SUPPLY_NETWORKS]: "Внутренние сети электроснабжения",
  [TypeOfWorksTypes.GAS_PIPELINE]: "Газопровод",
  [TypeOfWorksTypes.PALIFICATION]: "Забивка свай",
  [TypeOfWorksTypes.ROOF]: "Кровля",
  [TypeOfWorksTypes.INSTALLATION_AND_COMMISSIONING_OF_AUTOMATION_SYSTEMS]: "Монтаж и наладка систем автоматизации",
  [TypeOfWorksTypes.INSTALLATION_OF_ELEVATORS]: "Монтаж лифтов",
  [TypeOfWorksTypes.INSTALLATION_STRUCTURE]: "Монтаж строительных конструкций",
  [TypeOfWorksTypes.INSTALLATION_OF_TECHNOLOGICAL_EQUIPMENT_AND_PIPELINES]: "Монтаж технологического оборудования и трубопроводов",
  [TypeOfWorksTypes.EXTERNAL_FINISHING_WORKS]: "Наружные отделочные работы (фасад)",
  [TypeOfWorksTypes.EXTERNAL_WATER_SUPPLY_AND_SEWERAGE_NETWORKS]: "Наружные сети водопровода и канализации",
  [TypeOfWorksTypes.EXTERNAL_POWER_SUPPLY_NETWORKS]: "Наружные сети электроснабжения",
  [TypeOfWorksTypes.BEARING_AND_ENCLOSING_STRUCTURES]: "Несущие и ограждающие конструкции",
  [TypeOfWorksTypes.CIVIL_WORKS]: "Общестроительные работы",
  [TypeOfWorksTypes.FIRE_AND_SECURITY_AND_FIRE_ALARMS]: "Пожарная и охранно-пожарная сигнализация",
  [TypeOfWorksTypes.CABLING]: "Прокладка кабеля",
  [TypeOfWorksTypes.OTHER]: "Прочие",
  [TypeOfWorksTypes.WELDING]: "Сварочные",
  [TypeOfWorksTypes.HEATING_AND_VENTILATION_NETWORKS]: "Сети отопления и вентиляции",
  [TypeOfWorksTypes.COMMUNICATION_SIGNALING_AND_AUTOMATION_SYSTEMS]: "Системы связи, сигнализации и автоматизации",
  [TypeOfWorksTypes.HEATING_NETWORK]: "Тепловые сети",
  [TypeOfWorksTypes.TECHNOLOGICAL_SOLUTIONS]: "Технологические решения",
  [TypeOfWorksTypes.ROAD_CONSTRUCTION]: "Устройство автомобильных дорог",
  [TypeOfWorksTypes.CONSTRUCTION_OF_FOUNDATIONS]: "Устройство фундаментов",
};

export function getWorkTypeLabel(code: string | null | undefined): string {
  if (!code) return "-";
  return WorkLabels[code as TypeOfWorksEnum] ?? code;
}
